module.exports = __webpack_public_path__ + "static/media/miota.7237b8dc.svg";